import React from "react";
import { useOutletContext } from "react-router-dom";

function prodKey(campus) { return `uniforms_products_${String(campus || "gen").toLowerCase()}`; }
function load(campus) { try { const raw = localStorage.getItem(prodKey(campus)); return raw ? JSON.parse(raw) : []; } catch { return []; } }
function save(campus, data) { try { localStorage.setItem(prodKey(campus), JSON.stringify(data)); } catch { void 0; } }

export default function Products() {
  const { campus } = useOutletContext();
  const [rows, setRows] = React.useState(() => load(campus));
  const [form, setForm] = React.useState({ name: "", category: "", gender: "" });
  React.useEffect(() => setRows(load(campus)), [campus]);
  function add(e) {
    e.preventDefault();
    const next = [...rows, { ...form, id: `P-${Date.now()}` }];
    setRows(next); save(campus, next);
    setForm({ name: "", category: "", gender: "" });
  }
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Products — {campus.toUpperCase()}</h5>
        <form className="d-flex gap-2" onSubmit={add}>
          <input className="form-control" placeholder="Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
          <input className="form-control" placeholder="Category" value={form.category} onChange={e => setForm({ ...form, category: e.target.value })} />
          <select className="form-select" value={form.gender} onChange={e => setForm({ ...form, gender: e.target.value })}>
            <option value="">Gender</option>
            <option value="Boys">Boys</option>
            <option value="Girls">Girls</option>
            <option value="Unisex">Unisex</option>
          </select>
          <button className="btn btn-primary">Add</button>
        </form>
      </div>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="table-light"><tr><th>Name</th><th>Category</th><th>Gender</th></tr></thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan="3" className="text-center text-muted">No products</td></tr>
            ) : rows.map(r => (
              <tr key={r.id}>
                <td>{r.name}</td><td>{r.category || "-"}</td><td>{r.gender || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
